import React from 'react'

import { Dialog } from 'components'

const CancelEditDialog = (props) => (
  <Dialog
    {...props}
    id='cancel-edit-artwork-dialog'
    title='Warning'
    width={400}
    confirmLabel='Discard'
  >
    <p>
      Your changes have not been saved. To save them, press Cancel to go back
      then click Save followed by Close Edit. To discard your changes, hit
      Discard below.
    </p>
  </Dialog>
)

export default CancelEditDialog



// WEBPACK FOOTER //
// ./src/containers/ArtworkView/View/CancelEditDialog.js